<script lang="ts" setup>
import { useRouter } from 'vue-router'
const router = useRouter()
const jumpOutside = (url: string) => {
  window.open(url, '_blank');
}

const openTopic = (topicId:string) =>{
  if (topicId) {
    window.open(`${location.origin}/topic-activity/${topicId}`, '_blank')
    return
  }
}
</script>
<template>
  <div class="footer-wrap">
    <div class="footer">
      <div class="f-container clearfix">
        <div class="footer-logo fl">天桥艺术中心票务特约代理渠道：大麦网、猫眼、中票在线、大眼睛票务、票星球（非以上渠道购票所造成的损失由顾客自行承担）</div>
        <div class="footer-content fl">
          <div class="link"><a href="javascript:void();" @click="openTopic('6708da2e5d8ccc0001ca14f3')">公司简介</a><span>|</span><a
            href="javascript:void();" @click="openTopic('6708d3f672f1a300011144cb')" >人才招聘</a><span>|</span><a
            href="javascript:void();" @click="openTopic('6708d5fb4c51520001ea3ba7')">联系我们</a><span>|</span><a
            href="javascript:void();" @click="openTopic('6708d63801ea8f0001e06794')">商务合作</a><span>|</span><a
            href="javascript:void();" @click="openTopic('6708d6fd5aaf9d0001034706')">客户服务</a>
            <div class="copyright">
              <p>公司名称：北京天桥盛世剧院管理有限公司</p>
              <p>购票电话：400-635-3355</p>
              <p>地址：北京市西城区天桥南大街9号楼</p>
            </div>
            <p>网站备案号： <a target="_blank" href="https://beian.miit.gov.cn" class="beian">京ICP备2025113010号-1</a> Copyright 2015 ©
              tartscenter.com 北京天桥盛世剧院管理有限公司版权所有</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.footer-wrap {
  .footer {
    border-top: 2px solid #A9823E;
    height: 220px;
    border-width: 2px 0 2px 0;
    background: #f4f4f4;
  }

  .footer .f-container {
    margin: 24px auto 0 auto;
    width: 1062px;
    overflow: hidden;
    display: flex;
  }

  .footer .footer-logo {
    padding-top: 70px;
    width: 305px;
    background: url(../../../assets/image/header-footer/logo.png) no-repeat left top;
    vertical-align: middle;
    border-right: 1px solid rgba(0,0,0,0.1);;
    color: rgba(0,0,0,0.4);
    background-size: 100% auto;
    font-size: 14px;
    padding-right: 20px;
  }

  .footer .footer-content {
    margin-left: 30px;
    width: 740px;
    color: rgba(0,0,0,0.4);
    font-size: 14px;
  }

  .footer .footer-content p {
    font-size: 14px;
    color: #888888;
    line-height: 26px;
  }

  .footer .footer-content .link {
    margin-bottom: 5px;
    line-height: 32px;
    vertical-align: middle;
  }

  .footer .footer-content .link a {
    font-size: 16px;
    color: rgba(0,0,0,0.9);
  }

  .footer .footer-content .link a:hover {
    color: #a9823e;
  }

  .footer .footer-content .link span {
    margin: 0 10px;
    font-size: 14px;
    color: rgba(0,0,0,0.9);
  }
  .beian{
    font-size: 14px !important;
  }
}
</style>
